<template>
  <div class="page_ blue_">
    <div class="bg_">
      <div class="con_">
        <a-tabs :default-active-key="tabIndex" @change="tabsChange">
          <a-tab-pane key="1" :tab="$t('sublist.appointing')">
            <a-table
              :pagination="paginationOptions"
              :columns="columns"
              :data-source="data | filterData1"
              @change="handleTableChange"
            >
              <a slot="Operation" slot-scope="text, record" class="Operation">
                <span @click="() => look(record)">{{
                  $t("sublist.look")
                }}</span>
                <a-popconfirm
                  :title="$t('sublist.cancelText')"
                  :ok-text="$t('sublist.oktext')"
                  :cancel-text="$t('sublist.canceltext')"
                  @confirm="cancel(record)"
                  v-if="record.estQuery.querysts == 'O'"
                >
                  <span>{{ $t("sublist.cancel") }}</span>
                </a-popconfirm>
              </a>
            </a-table>
          </a-tab-pane>
          <a-tab-pane key="2" :tab="$t('sublist.appoined')">
            <a-table
              :columns="columns"
              :data-source="data | filterData2"
              :pagination="paginationOptions"
            >
              <a slot="Operation" slot-scope="text, record" class="Operation">
                <span @click="() => look(record, 'again')">{{
                  $t("sublist.look")
                }}</span>
                <span @click="() => again(record, 'again')">{{
                  $t("sublist.again")
                }}</span>
              </a>
            </a-table>
          </a-tab-pane>
          <a-button
            slot="tabBarExtraContent"
            type="primary"
            @click="toSubscribe"
            >{{ $t("sublist.yuyueBtn") }}</a-button
          >
        </a-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/utils/api";
import moment from "moment";
export default {
  data() {
    return {
      tabIndex: "1",
      data: [],
      providerCode: this.$route.query.provider_code,
      language: "",
      lang: "",
      paginationOptions: {
        hideOnSinglePage: true
      }
    };
  },
  computed: {
    columns() {
      const columnsing = [
        {
          title: this.$t("sublist.orderNumber"),
          dataIndex: "estQuery.queryno",
          key: "estQuery.queryno",
          ellipsis: true,
          align: "center"
        },
        {
          title: this.$t("sublist.Name"),
          dataIndex: "queryApp.providerName",
          key: "queryApp.providerName",
          ellipsis: true,
          align: "center"
        },
        {
          title: this.$t("sublist.Section"),
          dataIndex: "queryApp.department",
          key: "queryApp.department",
          ellipsis: true,
          align: "center"
        },
        {
          title: this.$t("sublist.Doctors"),
          dataIndex: "queryApp.doctor",
          key: "queryApp.doctor",
          ellipsis: true,
          align: "center"
        },
        {
          title: this.$t("sublist.Attendees"),
          dataIndex: "estQuery.empName",
          key: "estQuery.empName",
          ellipsis: true,
          align: "center"
        },
        {
          title: this.$t("sublist.Time"),
          key: "estQuery.appDate",
          ellipsis: true,
          align: "center",
          customRender: (text, record, index) => {
            if (text.estQuery) {
              let str = new Date(text.queryApp.appDate).toLocaleString();
              if (this.lang == "ENGLISH") {
                if (str.indexOf("上午") > -1) {
                  return (
                    str.substring(0, str.indexOf("上午")) +
                    "AM" +
                    str.substring(str.indexOf("上午") + 2, str.length - 3)
                  );
                }
                if (str.indexOf("下午") > -1) {
                  return (
                    str.substring(0, str.indexOf("下午")) +
                    "PM" +
                    str.substring(str.indexOf("下午") + 2, str.length - 3)
                  );
                }
              } else {
                return str.substring(0, str.length - 3);
              }
              return new Date(text.queryApp.appDate).toLocaleString();
            }
          }
        },
        {
          title: this.$t("sublist.Status"),
          key: "estQuery.querysts",
          ellipsis: true,
          align: "center",
          customRender: (text, record, index) => {
            if (text.estQuery) {
              switch (text.estQuery.querysts) {
                case "P":
                  return (
                    <a href="javascript:;" style="color:green">
                      {this.$t("sublist.P")}
                    </a>
                  );
                case "I":
                  return (
                    <a href="javascript:;" style="color:green">
                      {this.$t("sublist.I")}
                    </a>
                  );
                case "O":
                  return (
                    <a href="javascript:;" style="color:red">
                      {this.$t("sublist.O")}
                    </a>
                  );
                case "C":
                  return (
                    <a href="javascript:;" style="color:green">
                      {this.$t("sublist.C")}
                    </a>
                  );
                case "L":
                  return (
                    <a href="javascript:;" style="color:red">
                      {this.$t("sublist.L")}
                    </a>
                  );
                case "F":
                  return (
                    <a href="javascript:;" style="color:red">
                      {this.$t("sublist.F")}
                    </a>
                  );
                default:
                  return (
                    <a href="javascript:;" style="color:red">
                      {this.$t("sublist.P")}
                    </a>
                  );
              }
            }
          }
        },
        {
          title: this.$t("sublist.Operation"),
          dataIndex: "address",
          key: "address 6",
          ellipsis: true,
          align: "center",
          scopedSlots: { customRender: "Operation" }
        }
      ];
      return columnsing;
    }
  },
  mounted() {},
  filters: {
    filterData1: val => {
      return val.filter(e => {
        return (
          e.estQuery.querysts == "P" ||
          e.estQuery.querysts == "I" ||
          e.estQuery.querysts == "O"
        );
      });
    },
    filterData2: val => {
      return val.filter(e => {
        return (
          e.estQuery.querysts == "C" ||
          e.estQuery.querysts == "L" ||
          e.estQuery.querysts == "F"
        );
      });
    }
  },
  created() {
    this.language = this.$i18n.locale;
    this.lang = this.$i18n.locale == "en-us" ? "ENGLISH" : "CHINAESE";
    this.getappointList();
    this.tabIndex = localStorage.getItem("pageIndex") || "1";
  },
  methods: {
    /**
     * @name 标签的切换
     */
    tabsChange(keys) {
      this.tabIndex = keys;
      localStorage.setItem("pageIndex", this.tabIndex);
    },
    /**
     * @name 翻页
     */
    handleTableChange(pagination, filters, sorter) {
      let page = pagination.current;
      let pageSize = pagination.pageSize;
      console.log(pagination, filters, sorter);
    },
    /**
     * @name 取消预约
     */
    cancel(data) {
      console.log(data);
      api.CancelAppoint(data.estQuery.queryno).then(res => {
        console.log(res);
        if (res.data.code == 200) {
          let message =
            this.$i18n.locale == "en-us"
              ? "Successfully canceled the appointment！"
              : "取消预约成功！";
          this.$message.success(message);
          this.getappointList();
        }
      });
    },
    /**
     * @name 查看预约
     */
    look(data, type) {
      console.log(data);
      console.log(type);
      this.$router.push({
        name: `SubscribeDetails`,
        query: {
          queryno: data.estQuery.queryno,
          type: type
        }
      });
    },
    /**
     * @name 再次预约
     */
    again(data, str) {
      console.log(data);
      this.$router.push({
        name: `Subscribe`,
        query: {
          queryno: data.estQuery.queryno,
          memberNo: data.memberControlNo,
          again: str
        }
      });
    },
    //获取预约列表
    getappointList(memberControlNo) {
      api
        .appointList({ memberControlNo: memberControlNo, language: this.lang })
        .then(res => {
          console.log(res);
          if (res.data.code == 200) {
            this.data = res.data.data;
          }
        });
    },
    // 取消预约
    CancelAppoint(queryno) {
      api.CancelAppoint(queryno).then(res => {
        console.log(res);
        if (res.data.code == 200) {
          let message =
            this.$i18n.locale == "en-us"
              ? "Successfully canceled the appointment！"
              : "取消预约成功！";
          this.$message.success(message);
          this.getappointList();
        }
      });
    },
    /**
     * @name 去预约
     */
    toSubscribe(data) {
      console.log(data);
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      let cardList = JSON.parse(localStorage.getItem("cardList"));
      console.log(userInfo);
      let selectCard = cardList.filter(item => item.Card_no == userInfo.cardNo);
      // return
      this.$router.push({
        name: "Subscribe",
        query: {
          Card_no: selectCard[0].Card_no,
          Employee_name: selectCard[0].Employee_name,
          Payor_code: selectCard[0].Payor_code,
          memberNo: selectCard[0].memberNo
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.page_ {
  width: 100%;
  .bg_ {
    background-color: #fff;
    border-radius: 10px;
    padding-bottom: 10px;
    > .tit_ {
      padding: 15px 30px;
      border: 1px solid #f3f3f3;
      font-size: 16px;
      color: #394155;
      font-weight: bold;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    > .con_ {
      padding: 20px 30px 0px;
      .Operation {
        span {
          margin: 0 5px;
        }
      }
    }
  }
}
.blue_ {
  color: #2c5acc;
  font-weight: bold;
}
</style>
